const initialstate = {
    data:[],
    viewdocdata:[],
    Chatdata:[],
    successdata:[],
    approvedata:[],
    rejectdata:[],
    
}

const ViewOrgReducers =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_VIEWDOC_DATA_SUCCESS':
                return {... state, viewdocdata:action.payload};
                case 'VIEW_DATA_SUCCESS':
                return {... state, Chatdata:action.payload};
                case 'FETCH_DATA_SUCCESS_MAS':
            return{ ...state, successdata: action.payload }
                case 'Approve_DATA_SUCCESS':
                return {... state, approvedata:action.payload};
                case 'Reject_DATA_SUCCESS':
                    return {... state, rejectdata:action.payload};
                  
      
            default :
            return state;
    }
};
export default ViewOrgReducers;

